<template>
  <!--投诉建议 -->
  <div class="layout">
    <Layout>
      <!-- 头 -->
      <Header>
        <Menu theme="light" mode="horizontal" active-name="">
          <div class="layout-logo">
            <a href="/"> <img src="../assets/logo-title-v3.png" alt="" /></a>
          </div>
          <div class="layout-nav">
            <!-- <MenuItem style="font-size: 18px !important" name="1" to="/sourceInformation">
            aa信息
            </MenuItem>
            <MenuItem to="/vehicleInformation" style="font-size: 18px !important" name="2">
            bb信息
            </MenuItem> -->
            <MenuItem to="/complaintPublicity" style="font-size: 18px !important" name="3">
            评价公示
            </MenuItem>
            <MenuItem to="/evaluationPublicity" style="font-size: 18px !important" name="4">
            投诉公示
            </MenuItem>
            <Submenu name="5">
              <template slot="title"><span style="font-size: 18px !important">联系客服</span>
              </template>
              <MenuItem to="/customerServiceContact" style="
                  font-size: 15px !important;
                  padding-left: 35px !important;
                " name="2-1">投诉建议</MenuItem>
              <MenuItem to="/contactUs" style="
                  font-size: 15px !important;
                  padding-left: 35px !important;
                " name="2-2">联系我们</MenuItem>
            </Submenu>
          </div>
        </Menu>
      </Header>
      <div class="Header-img">
        <div class="main-contents">
          <div>
            <span class="main-contents-guide">用户指南 </span>
          </div>
        </div>
      </div>
      <!-- 中 -->
      <Content>
        <div class="userGuide-Content">
          <div style="display: flex">
            <div class="userGuide-Content-left">
              <div class="flow-icon">
                <img src="../assets/flow-icon1.png" alt="" />
              </div>
              <div>
                <img src="../assets/flow-line1.png" alt="" />
              </div>
              <div class="flow-icon">
                <img src="../assets/flow-icon2.png" alt="" />
              </div>
              <div>
                <img src="../assets/flow-line2.png" alt="" />
              </div>
              <div class="flow-icon">
                <img src="../assets/flow-icon3.png" alt="" />
              </div>
              <div style="margin-bottom: 40px">
                <img src="../assets/flow-line3.png" alt="" />
              </div>
            </div>
            <!-- 货主 -->
            <div>
              <div class="userGuide-Content-right">
                <div class="Content-right-title">
                  <div style="display: flex">
                    <div><img src="../assets/title-icon.png" alt="" /></div>
                    <div class="Content-right-title-font">货主如何下载</div>
                  </div>
                  <div class="Content-right-text">
                    <div style="font-size: 17px !important">
                      方式一：扫描右侧/二维码关注微信公众号，进行下载。
                    </div>
                    <div style="font-size: 17px !important">
                      方式二：：登录各大主流App Store，搜索“------”完成下载。
                    </div>
                  </div>
                </div>
                <div class="qr-img">
                  <!-- <img
                    style="width: 125px; height: 125px"
                    src="../assets/official.jpg"
                    alt=""
                  /> -->
                </div>
              </div>

              <div class="userGuide-Content-rights">
                <div class="Content-right-title">
                  <div style="display: flex">
                    <div><img src="../assets/title-icon.png" alt="" /></div>
                    <div class="Content-right-title-font">货主如何入驻平台</div>
                  </div>
                  <div class="Content-right-text">
                    <div style="font-size: 17px !important">
                      1.打开App，点击【注册】，输入基础信息，进行手机验证，等待后台进行审核。
                    </div>
                    <div style="font-size: 17px !important">
                      2.打开电脑端客户中心，填写信息，进行手机验证，等待后台进行审核。
                    </div>
                  </div>
                </div>
              </div>
              <div class="userGuide-Content-right">
                <div class="Content-right-title">
                  <div style="display: flex">
                    <div><img src="../assets/title-icon.png" alt="" /></div>
                    <div class="Content-right-title-font">货主如何发布货源</div>
                  </div>
                  <div class="Content-right-text">
                    <div style="font-size: 17px !important">
                      1.登录App，点击【货源发布】，输入货源信息，完成发布货源。
                    </div>
                    <div style="font-size: 17px !important">
                      2.登录电脑端客户中心系统，进入【货源发布】，输入货源信息，完成发布货源。
                    </div>
                  </div>
                </div>
              </div>

              <div style="margin-top: 87px">
                <!-- 承运商 -->
                <div class="userGuide-Carrier-right">
                  <div class="Content-right-title">
                    <div style="display: flex">
                      <div><img src="../assets/title-icon.png" alt="" /></div>
                      <div class="Content-right-title-font">承运商如何下载</div>
                    </div>
                    <div class="Content-right-text">
                      <div style="font-size: 17px !important">
                        方式一：扫描右侧/二维码关注微信公众号，进行下载。
                      </div>
                      <div style="font-size: 17px !important">
                        方式二：：登录各大主流App
                        Store，搜索“------”完成下载。
                      </div>
                    </div>
                  </div>
                  <div class="qr-img">
                    <!-- <img
                      style="width: 125px; height: 125px"
                      src="../assets/official.jpg"
                      alt=""
                    /> -->
                  </div>
                </div>

                <div class="userGuide-Carrier-rights">
                  <div class="Content-right-title">
                    <div style="display: flex">
                      <div><img src="../assets/title-icon.png" alt="" /></div>
                      <div class="Content-right-title-font">
                        承运商如何入驻平台
                      </div>
                    </div>
                    <div class="Content-right-text">
                      <div style="font-size: 17px !important">
                        致电客服18752036980，提供相关材料，由平台开通承运商账号
                      </div>
                    </div>
                  </div>
                </div>
                <div class="userGuide-Carrier-right">
                  <div class="Content-right-title">
                    <div style="display: flex">
                      <div><img src="../assets/title-icon.png" alt="" /></div>
                      <div class="Content-right-title-font">
                        货主如何发布货源
                      </div>
                    </div>
                    <div class="Content-right-text">
                      <div style="font-size: 17px !important">
                        1.登录App，点击【接单】，选择合适的货源，点击接单，完成接单。
                      </div>
                      <div style="font-size: 17px !important">
                        2.登录电脑端承运商系统，进入【货源管理】，选择合适的货源，点击接单，完成接单。
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div style="margin-top: 87px">
                <!-- 司机 -->
                <div class="userGuide-driver-right">
                  <div class="Content-right-title">
                    <div style="display: flex">
                      <div><img src="../assets/title-icon.png" alt="" /></div>
                      <div class="Content-right-title-font">司机如何下载</div>
                    </div>
                    <div class="Content-right-text">
                      <div style="font-size: 17px !important">
                        方式一：扫描右侧/二维码关注微信公众号，进行下载。
                      </div>
                      <div style="font-size: 17px !important">
                        方式二：：登录各大主流App
                        Store，搜索“------”完成下载。
                      </div>
                    </div>
                  </div>
                  <div class="qr-img">
                    <!-- <img
                      style="width: 125px; height: 125px"
                      src="../assets/official.jpg"
                      alt=""
                    /> -->
                  </div>
                </div>

                <div class="userGuide-driver-rights">
                  <div class="Content-right-title">
                    <div style="display: flex">
                      <div><img src="../assets/title-icon.png" alt="" /></div>
                      <div class="Content-right-title-font">
                        司机如何入驻平台
                      </div>
                    </div>
                    <div class="Content-right-text">
                      <div style="font-size: 17px !important">
                        1.打开App，点击【注册】，进行手机验证；
                      </div>
                      <div style="font-size: 17px !important">2.完善资料；</div>
                      <div style="font-size: 17px !important">
                        3.等待后台进行审核。
                      </div>
                    </div>
                  </div>
                </div>
                <div class="userGuide-driver-right">
                  <div class="Content-right-title">
                    <div style="display: flex">
                      <div><img src="../assets/title-icon.png" alt="" /></div>
                      <div class="Content-right-title-font">司机如何接单</div>
                    </div>
                    <div class="Content-right-text">
                      <div style="font-size: 17px !important">
                        1.登录App，点击【货源大厅】；
                      </div>
                      <div style="font-size: 17px !important">
                        2.选择合适的货源，点击【接单】，完成接单。
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Content>
      <!-- 尾 -->
      <Footer class="layout-footer-center">
        <div style="
            width: 100%;
            height: 100%;
            background-image: linear-gradient(#252c37, #1e252c);
          ">
          <div style="width: 100%; height: 50px"></div>
          <!-- 低 -->
          <div style="display: flex">
            <div class="Footer-text-left">仓鼠潮玩欢迎您的加入！</div>
            <div class="Footer-text-right">
              <p class="Footer-text-title">南京云游阁信息科技有限公司</p>
              <!-- <p class="opt opt-let">
                <span class="title">帮助中心</span>
                <a class="a-link" href="#">用户指南</a>
              </p> -->
              <!-- <p class="opt opt-let">
                <span class="title">关于我们</span>
                <router-link class="a-link" :to="'/contactUs'">
                  联系我们
                </router-link>
              </p> -->
              <p class="opt opt-let2">
                <span style=" margin-left: -1px;" class="title">服务热线</span>
                <router-link class="a-link1" :to="'#'">
                  18752036980
                </router-link>
              </p>
            </div>
          </div>
          <!-- 线 -->
          <div class="Line">
            <div class="LineClik"></div>
          </div>
          <!-- 低 -->
          <div>
            <!-- <p style="line-height: 18px">
              <img src="../assets/hui.png" style="width: 18px; height: 18px; vertical-align: middle" alt="" />
              <a style="line-height: 18px; color: #ffffff"
                href="http://www.beian.gov.cn/portal/recordQuery?token=cc5dd992-aa8e-47e8-94b8-2c2e2feadf98"
                target="_blank">豫公网安备：41080039010-21001号</a>&emsp;
              <span style="color: #b4c1cd">增值电信业务经营许可证：</span>
              <a href="https://beian.miit.gov.cn/#/Integrated/index" style="line-height: 18px; color: #ffffff"
                target="_blank">豫B2-20210727</a>
            </p> -->
            <p style="padding-bottom: 20px; color: #b4c1cd">
              <!-- © Copyright 2020-2023 -->
              <span><a style="color: #ffffff" href="#">
                  南京云游阁信息科技有限公司
                </a></span><br />
              All Rights Reserved.
              <a style="color: #ffffff" href="https://beian.miit.gov.cn/#/Integrated/index"
                target="_blank">苏ICP备2024094700号-5</a>
            </p>
            <div>
              <div style="width: 100%; height: 10px"></div>
            </div>
          </div>
        </div>
      </Footer>
    </Layout>
  </div>
</template>
<script>
export default {
  data() {
    return {
      value1: 0,
      height: 0,
      one: false,
      criteriaIcon: true,
      wpList: [{ name: "投诉" }, { name: "建议" }],
      active: "投诉",
      form: {
        content: "",
        name: "",
      },
    };
  },
  created() {
    this.init();
  },
  mounted() {},
  methods: {
    init() {},
    selected(name) {
      this.active = name;
    },
  },
};
</script>
<style scoped >
.Header-img {
  background-image: url("../assets/top-banners.png");
  width: 100%;
  height: 150px;
  line-height: 150px;
  position: relative;
}
.main-contents,
.userGuide-Content {
  /* width: 1200px; */
  /* position: relative; */
  /* bottom: -60px;
  left: 320px;
  z-index: 10; */
  /* margin: 0 auto; */
  display: flex;
  justify-content: center;
}
.main-contents-guide {
  font-size: 24px;
  font-weight: 400;
  color: #ffffff;
  position: relative;
  cursor: pointer;
  padding-bottom: 8px;
}
.userGuide-Content-left {
  width: 256px;
  padding-left: 60px;
  margin-left: 50px;
}
.userGuide-Content-right {
  margin-top: 20px;
  background: linear-gradient(90deg, #d7e5fd 0%, #fbfdff 100%);
  border-radius: 40px;
  height: 170px;
  padding: 20px 0px 0 36px;
  box-sizing: border-box;
  position: relative;
  margin-bottom: 10px;
  display: flex;
  justify-content: space-between;
}
.userGuide-Content-rights {
  background: linear-gradient(-90deg, #d7e5fd 0%, #fbfdff 100%);
  border-radius: 40px;
  height: 170px;
  padding: 20px 0px 0 36px;
  box-sizing: border-box;
  position: relative;
  margin-bottom: 10px;
  display: flex;
  justify-content: space-between;
}
.flow-icon {
  margin-left: -120px;
  margin-top: 20px;
  margin-bottom: 20px;
}
.Content-right-title {
  font-size: 20px;
  font-weight: bold;
  margin: 5px 0 10px 0;
  color: #3dc1a4;
}
.Content-right-title-font {
  font-size: 20px !important;
  font-weight: bold;
  margin: 1px 0 10px 0;
  color: #3dc1a4;
  margin-left: 10px;
}
.Content-right-text {
  margin-left: 39px;
  color: #333333;
  line-height: 30px;
}
.qr-img {
  width: 125px;
  height: 125px;
  margin: 20px;
}
.userGuide-Carrier-right {
  background: linear-gradient(90deg, #d8fbf1 0%, #fbfdff 100%);
  border-radius: 40px;
  height: 170px;
  padding: 20px 0px 0 36px;
  box-sizing: border-box;
  position: relative;
  margin-bottom: 10px;
  display: flex;
  justify-content: space-between;
}
.userGuide-Carrier-rights {
  background: linear-gradient(-90deg, #d8fbf1 0%, #fbfdff 100%);
  border-radius: 40px;
  height: 170px;
  padding: 20px 0px 0 36px;
  box-sizing: border-box;
  position: relative;
  margin-bottom: 10px;
  display: flex;
  justify-content: space-between;
}
.userGuide-driver-right {
  background: linear-gradient(90deg, #fff4e8 0%, #fbfdff 100%);
  border-radius: 40px;
  height: 170px;
  padding: 20px 0px 0 36px;
  box-sizing: border-box;
  position: relative;
  margin-bottom: 10px;
  display: flex;
  justify-content: space-between;
}
.userGuide-driver-rights {
  background: linear-gradient(-90deg, #fff4e8 0%, #fbfdff 100%);
  border-radius: 40px;
  height: 170px;
  padding: 20px 0px 0 36px;
  box-sizing: border-box;
  position: relative;
  margin-bottom: 10px;
  display: flex;
  justify-content: space-between;
}
/*     000000000000000000000000 */
.ivu-layout-header {
  padding: 0 !important;
  height: 89px !important;
  background: #fff !important;
  box-shadow: 0px 3px 7px 0px rgb(0 0 0 / 19%) !important;
}
.ivu-menu-horizontal {
  height: 89px !important;
  line-height: 89px !important;
  background: #fff !important;
  box-shadow: 0px 3px 7px 0px rgb(0 0 0 / 19%) !important;
}
.layout {
  /* border: 1px solid #d7dde4; */
  background: #f5f7f9;
  position: relative;
  border-radius: 4px;
  /* overflow: hidden; */
}
.ivu-layout-footer {
  padding: 0 !important;
}
.layout-logo {
  width: 100px;
  height: 30px;
  /* background: #5b6270; */
  border-radius: 3px;
  float: left;
  position: relative;
  top: 30px;
  left: 30px;
}
.layout-logo img {
  height: 44px;
  position: relative;
  top: -13px;
  left: 50px;
}

.layout-nav {
  width: 650px;
  margin: 0 auto;
  margin-right: 20px;
}
.layout-footer-center {
  text-align: center;
}

.Footer-text-left {
  font-size: 40px;
  color: #065fc3;
  display: inline-block;
  font-style: italic;
  margin-left: 23%;
  margin-top: 45px;
}
.Footer-text-right {
  width: 321px;
  display: inline-block;
  margin-left: 96px;
  /* color: #ffffff;
  position: absolute;
  top: 50%;
  transform: translateY(-50%); */
}
.Footer-text-title {
  font-size: 22px;
  margin-bottom: 10px;
  color: #fff;
}
.opt {
  line-height: 2.2;
}
.opt-let {
  margin-left: -79px;
}
.opt-let2 {
  width: 400px;
  margin-left: -59px;
  display: inline-block;
}
.title {
  font-size: 16px;
  color: #b4c1cd;
  border-right: 1px #b4c1cd solid;
  padding-right: 15px;
}
.a-link {
  font-size: 16px;
  color: #ffffff;
  margin-left: 15px;
}
.a-link1 {
  font-size: 16px;
  color: #ffffff;
  margin-left: 14px;
}
.Line {
  margin-top: 40px;
  margin-bottom: 40px;
  /* border-bottom: 1px solid #fff; */
  z-index: 9999;
}
.LineClik {
  position: relative;
  bottom: 0px;
  left: 1px;
  width: 99.5%;
  height: 1px;
  background-color: #3f4955;
}
.ivu-menu-light.ivu-menu-horizontal .ivu-menu-item-active,
.ivu-menu-light.ivu-menu-horizontal .ivu-menu-item:hover,
.ivu-menu-light.ivu-menu-horizontal .ivu-menu-submenu-active,
.ivu-menu-light.ivu-menu-horizontal .ivu-menu-submenu:hover {
  color: rgb(33, 195, 143);
  border: 0;
}
</style>


// WEBPACK FOOTER //
// src/pages/userGuide.vue